import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { imagePropTypes } from 'utils/proptypes';
import { safeGet, className } from 'utils';
import styles from './commonwealthSlide.module.scss';

const CommonwealthSlide = ({
  image,
  headline,
  copy,
  index,
  isActive,
  goToPreviousSlide,
  goToNextSlide,
  handleKeyDown,
}) => {
  const { url: imageURL } = safeGet(image, ['file', 'url'], ['description'], ['title']);
  const [touchStartX, setTouchStartX] = useState(0);
  const [touchEndX, setTouchEndX] = useState(0);

  const handleTouchStart = e => {
    // Get the start position of the touch
    const touchStart = e.touches[0].clientX;
    setTouchStartX(touchStart);
  };

  const handleTouchEnd = () => {
    const swipeDistance = touchEndX - touchStartX;
    //User swiped left
    if (swipeDistance < 0) {
      goToNextSlide();
      //User swiped right
    } else if (swipeDistance > 0) {
      goToPreviousSlide();
    }
  };

  const handleTouchMove = e => {
    // Get the end position of the touch
    setTouchEndX(e.changedTouches[0].clientX);
  };

  return (
    <div
      aria-roledescription="slide"
      aria-label={`Slide ${index + 1}`}
      onKeyDown={e => handleKeyDown(e)}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      role="button"
      tabIndex={0}
      {...className(styles.cwSlide, isActive && styles.isActive)}>
      <div
        className={styles.cwSlideImage}
        style={{
          backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 50%, rgba(48, 74, 61, 0.80) 80%), url(${`${imageURL}?w=678`})`,
        }}>
        <div className={styles.cwSlideText}>
          <h1 className={styles.cwSlideHeader}>{headline}</h1>
          <p className={styles.cwSlideCopy}>{copy}</p>
        </div>
      </div>
    </div>
  );
};

CommonwealthSlide.propTypes = {
  copy: PropTypes.string.isRequired,
  goToPreviousSlide: PropTypes.func.isRequired,
  goToNextSlide: PropTypes.func.isRequired,
  handleKeyDown: PropTypes.func.isRequired,
  headline: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  image: imagePropTypes.isRequired,
  isActive: PropTypes.bool,
};

export default CommonwealthSlide;
